import { render } from "./button.vue?vue&type=template&id=91a451bc&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=91a451bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-91a451bc"

export default script